import UpdatePermissionDialog from './UpdatePermissionDialog';

export default UpdatePermissionDialog;